import React from 'react';
import _orderBy from 'lodash/orderBy';
import FieldCommentWrapper from 'common/components/FieldCommentWrapper';
import featureFlags from 'common/helpers/featureFlags';
import ConnectedContentItem from '../../../common/components/ConnectedContentItem/ConnectedContentItem';
import './NarrativeSection.scss';

const NarrativeSection = ({
  title,
  narratives,
  index = null,
  noConnectedContentTitle = `No connected ${title}`,
  error,
  fieldKey,
  sortByDateModified = true,
  isStructuredAnalysis = false,
}) => {
  const titleIdentifier = title && title.replace(/\s/g, '-').toLowerCase();
  const titleIdentifierWithIndex =
    titleIdentifier + (index !== null ? `-${index}` : '');
  const hasNarratives = narratives.length;

  const sectionClasses = [
    'narrative-section',
    `narrative-section-${titleIdentifier}`,
  ];
  if (!hasNarratives) {
    sectionClasses.push('narrative-section-empty');
  }

  let sortedNarratives = narratives;
  if (sortByDateModified) {
    sortedNarratives = _orderBy(narratives, ['dateModified'], ['desc']);
  }

  const titleElement = !isStructuredAnalysis ? (
    <FieldCommentWrapper fieldKey={fieldKey}>{title}</FieldCommentWrapper>
  ) : (
    title
  );

  return (
    <div
      className={sectionClasses.join(' ')}
      data-testid={`narrative-section-${titleIdentifierWithIndex}`}
    >
      <div
        className="narrative-section-title"
        data-testid={`narrative-section-title-${titleIdentifierWithIndex}`}
      >
        {titleElement}
      </div>
      {!error && (
        <div className="narrative-section__list">
          {sortedNarratives.length ? (
            sortedNarratives.map((narrative) => (
              <ConnectedContentItem
                key={`${narrative.title}-${narrative.contentId}-${narrative.contentThreadId}`}
                content={narrative}
                hideTextVersion={featureFlags.isVersioningPhase1Enabled}
              />
            ))
          ) : (
            <div
              className="narrative-card narrative-card-empty"
              data-testid={`narrative-section-empty-${titleIdentifierWithIndex}`}
            >
              {noConnectedContentTitle}
            </div>
          )}
        </div>
      )}
      {error && (
        <div className="narrative-error">{`Error loading ${title}`}</div>
      )}
    </div>
  );
};

export default NarrativeSection;
